import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Chip from '@material-ui/core/Chip';

const styles = theme => ({

  root: {
    width: "100%",
    maxWidth: 850,
    height: 90,
    margin: "14px auto",
    borderRadius: 24,
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.15)",
    cursor: "pointer",
    transition: "all 0.2s ease",

    "&:hover": {
      transform: "scale(1.01)",
      boxShadow: "0px 12px 28px rgba(0, 0, 0, 0.2)"
    },

    [theme.breakpoints.up("lg")]: {
      height: 110,
      maxWidth: 1000,
    }
  },

  left: {
    width: 140,
    height: "100%",
    background: "linear-gradient(180deg, #F1633A, #C84C2D)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  idadeNumero: {
    color: "#FFFFFF",
    fontWeight: 700,
    fontSize: 30,
    lineHeight: 1,

    [theme.breakpoints.up("lg")]: {
      fontSize: 36,
    }
  },

  idadeLabel: {
    color: "#FFFFFF",
    fontWeight: 500,
    fontSize: 14,
  },

  right: {
    flex: 1,
    backgroundColor: "#E5E5E5",
    height: "100%",
    display: "flex",
    alignItems: "center",
    paddingLeft: theme.spacing(4),
  },

  numero: {
    color: "#F1633A",
    fontWeight: 700,
    fontSize: 30,
    marginRight: theme.spacing(1),

    [theme.breakpoints.up("lg")]: {
      fontSize: 38,
    }
  },

  texto: {
    color: "#F1633A",
    fontWeight: 600,
    fontSize: 16,
  },

  chipAusente: {
    border: "1px solid #C70707",
    color: "#C70707",
    backgroundColor: "transparent",
    fontWeight: 600,
    fontSize: 12,
  },

  chipRestricao: {
    border: "1px solid #B78809",
    color: "#B78809",
    backgroundColor: "transparent",
    fontWeight: 600,
    fontSize: 12,
  },
  
  rightIdade: {
    backgroundColor: "#E5E5E5",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingRight: theme.spacing(3),
    gap: theme.spacing(1),
  },

});

class IdadeCard extends React.Component {

  render() {

    const {
      classes,
      idade,
      presentes,
      ausentes,
      restricoes,
      onClick
    } = this.props;

    return (
      <Paper elevation={0} className={classes.root} onClick={onClick}>

        {/* ESQUERDA */}
        <div className={classes.left}>
          <Typography className={classes.idadeNumero}>
            {idade}
          </Typography>
          <Typography className={classes.idadeLabel}>
            anos
          </Typography>
        </div>

        {/* DIREITA */}
        <div className={classes.right}>
          <Typography className={classes.numero}>
            {presentes}
          </Typography>
          <Typography className={classes.texto}>
            Alunos presentes
          </Typography>
        </div>
        <div className={classes.rightIdade}>
          {ausentes > 0 && (
            <Chip
              label={`${ausentes} ausentes`}
              className={classes.chipAusente}
              size="small"
            />
          )}

          {restricoes > 0 && (
            <Chip
              label={`${restricoes} restrições`}
              className={classes.chipRestricao}
              size="small"
            />
          )}
        </div>
      </Paper>
    );
  }
}

IdadeCard.propTypes = {
  idade: PropTypes.number.isRequired,
  presentes: PropTypes.number.isRequired,
  ausentes: PropTypes.number.isRequired,
  restricoes: PropTypes.number.isRequired,
  onClick: PropTypes.func
};

export default withStyles(styles)(IdadeCard);